<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>{{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-tabs v-model="tab">
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab v-for="item in items" :key="item" @click="getAccounts(item)">
                    {{ item }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items" :key="item">
                    <v-data-table
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                        :headers="headers"
                        :items="users"
                        sort-by="Name"
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Users"
                        :search="search"
                    >

                        <template v-slot:item.Progress="{ item }">
                            <v-progress-linear
                                :background-opacity="0.3"
                                :buffer-value="100"
                                :height="25"
                                :width="150"
                                :rounded="true"
                                :value="item.Progress"
                            >
                                <div v-if="item.Progress != null" color="white">{{ item.Progress }}%</div>
                                <div v-else>0%</div>

                            </v-progress-linear>
                        </template>

                        <template v-slot:item.VerificationStatus="{ item }">
                            <v-chip
                                class="ma-2"
                                :color="item.VerificationStatus === 'Pending' ? 'yellow' : 'green'"
                                x-small
                            >
                                <span
                                    :class="item.VerificationStatus === 'Pending' ? 'black--text' : 'white--text'">{{
                                        item.VerificationStatus
                                    }}</span>
                            </v-chip>
                        </template>

                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>
                                    <v-btn class="mb-2 hidden-sm-and-down" to="/userprofile">
                                        My Account
                                    </v-btn>
                                    <v-btn small class="mb-2 hidden-md-and-up" to="/userprofile">
                                        My Account
                                    </v-btn>
                                </v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>

                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    flat
                                    solo-inverted
                                    hide-details
                                    prepend-inner-icon="search"
                                    label="search"
                                    class="hidden-sm-and-down"
                                    @input="debouncedFetchData"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn color="#2b3990" dark class="mb-2 hidden-sm-and-down" @click="showAdd()"
                                >
                                    <v-icon left>add</v-icon>

                                    Add User
                                </v-btn>

                                <v-btn small color="#2b3990" dark class="mb-2 hidden-md-and-up" @click="showAdd()"
                                >
                                    <v-icon left>add</v-icon>

                                    Add User
                                </v-btn>

                            </v-toolbar>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="hidden-md-and-up pa-2"
                                @input="debouncedFetchData"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.Name="{ item }">
                           <span :class="getUserClass(item)">
                                {{ item.Name }}
                              </span>

                            <v-icon
                                v-if="item.MedCertified"
                                dark
                                class="blue--text"
                                small
                            >
                                check_circle_outline
                            </v-icon>

                            <v-icon
                                v-if="item.FirstAid"
                                dark
                                class="red--text"
                                small
                            >
                                local_hospital
                            </v-icon>
                            <v-icon
                                v-if="item.SafetyCare"
                                dark
                                class="green--text"
                                small
                            >
                                local_hospital
                            </v-icon>
                            <v-icon
                                v-if="item.CertifiedDriver"
                                dark
                                class="indigo--text"
                                small
                            >
                                mdi-card-account-details-outline
                            </v-icon>
                            <v-icon
                                v-if="item.HRCMember"
                                dark
                                class="blue--text ml-1"
                                small
                            >
                                mdi-account-group
                            </v-icon>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="viewUser(item)">
                                description
                            </v-icon>
                            <v-icon small class="mr-2" @click="editAccount(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="deleteAccount(item)">
                                mdi-delete
                            </v-icon>
                            <v-icon small @click="changePassword(item)" class="ml-2">
                                mdi-account-key
                            </v-icon>
                            <!-- <v-icon small @click="addDeal(item)">
                              add
                            </v-icon> -->
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
        <Foot/>
        <PasswordDialog :dialogVisible="passdialog" @closeDialog="closeDialog" :employeeID="userID"  />
    </div>
</template>

<script>
import axios from 'axios'
import Foot from '../components/Footer'
import Swal from 'sweetalert2'

import { mapState  } from "vuex";
import PasswordDialog from "../views/employee/dialog/password.vue";
import debounce from 'lodash/debounce';


const url = require("../client_config/config").url;

export default {
    components: {
        Foot,
        PasswordDialog
    },
    data: function () {
        return {
            tab: null,
            items: ["Active Users", "Former Users"],
            userSelectedSalaryHistory: [],
            msg: false,
            editEmail: false,
            hide: false,
            search: "",
            text: "",
            newName: "",
            newEmail: "",
            newPassword: "",
            newRePass: "",
            newRole: "",
            birthMenu: false,
            anniversaryMenu: false,
            activePicker: null,
            birthDate: null,
            anniversaryDate: null,
            position: ["Admin", "House Manager", "Assistant Manager", "Direct Care Staff"],
            estatus: ["Full-Time", "Part-Time", "Terminated"],
            states: ["Utah", "Nevada"],
            carriers: [
                "AT&T",
                "Boost Mobile",
                "Cricket",
                "Metro PCS",
                "Sprint",
                "Straight Talk",
                "T-Mobile",
                "Verizon",
                "Virgin Mobile"],
            newDate: "",
            newProgram: [],
            newPhoneNumber: "",
            newPhoneCarrier: "",
            newAddress: "",
            newCity: "",
            newState: "",
            newZip: "",
            newRate: "",
            newRaise: "",
            newRaiseDate: "",
            newTerminationDate: "",
            newTerminationReason: "",
            newTerminationDocumentation: [],
            newHouseManaged: [],
            newAnnualReview: "",
            newPosition: "",
            newStatus: "",
            newReHireDate: "",
            newMedCertified: false,
            newFirstAid: false,
            newSafetyCare: false,
            newCertifiedDriver: false,
            newSecurityQuestion: "",
            client: "",
            clients: [],
            programs: [],
            // newAnswer: "",
            emailRules: [
                v => !!v || 'This is required',
                v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            requiredField: [
                v => (v && v.length > 0) || 'This is required',
            ],
            headers: [
                {
                    text: "Name",
                    align: "start",
                    sortable: false,
                    value: "Name",
                },
                {text: "Email", value: "Email"},
                // { text: "Company", value: "CompanyID" },
                {text: "Role", value: "Role"},
                {text: "Progress", value: "Progress"},
                {text: "Verification Status", value: "VerificationStatus"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            headersForSalary: [
                {
                    text: "Rate",
                    align: "start",
                    sortable: false,
                    value: "Rate",
                },
                {text: "Raise", value: "Raise"},
                {text: "RaiseDate", value: "RaiseDate"},
            ],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            menu2: false,
            menu3: false,
            menu4: false,
            menu5: false,
            menu6: false,
            menu7: false,
            menu8: false,
            menu9: false,
            users: [],
            former: [],
            temp: [],
            titleForm: "New Account",
            userID: "",
            HRCMember: false,
            ShiftLead: false,
            newReferrals: '',
            newPaychexID: '',
            userState: localStorage.getItem('userState'),
            isLoading: false,
            companies: [],
            newCompany: [],
            terminationStatus: "",
            newStaffSignature: null,
            showSignaturePad: true,
            userSignatureImgSrc: null,
            userInitialsImgSrc: null,
            userRole: localStorage.getItem('userRole'),
            birthDateMenu: false,
            anniversaryDateMenu: false,
            QIDP: false,
            BachelorsDegree: false,
            requiresSupervision: false,
            page: 1,
            pageCount: 1,
            itemCount: 0,
            options: {},
            selectedTab: 'Active Users',
            passdialog: false,
        };
    },

    computed: {
        // formTitle() {
        //   return this.editedIndex != 1 ? "New Item" : "Edit Item";
        // },

        filteredDRoles() {
            const userRole = localStorage.getItem('userRole');
            if(userRole !== 'SuperAdministrator'){
                return this.droles.filter( (drole) => {
                    return drole !== 'SuperAdministrator'
                })
            }
            return this.droles;

        },

        ...mapState({
          droles: 'userRoles',
      })

    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        birthMenu(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
        anniversaryMenu(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'))
        },
        options: {
            handler() {
                this.getAccounts(this.selectedTab);
            },
            deep: true
        },

        search: 'debouncedFetchData',
    },

    created() {
        // this.getAccounts();
        this.getPrograms();
        this.getClients();
        this.getCompanies();
    },

    methods: {

        signatureData(data) {
            this.newStaffSignature = data;
        },

        getColor(sts) {
            console.log({sts});
            if (sts === "New") return 'green'
            else if (sts === "Prospect") return 'orange'
            else if (sts === "Negotion") return 'blue'
            else return 'teal'
        },


        initialize() {
            this.users = [];
            this.companies = [];
            this.newCompany = [];
        },

        closeDialog(){
          this.passdialog = false;
          this.userID = "";
        },

        showAdd() {
            this.$router.push({ path: `/users/add-user`,
                query: {'newUser': 'true'}
            });
        },

        editAccount(item) {
            this.$router.push({
                path: `/users/update-user/${item._id}`,
                query: { newUser: 'false' }
            });

        },

        changePassword(item) {
            this.passdialog = true;
            this.userID = item._id;
        },


        async deleteAccount(item) {
            const id = item._id;
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "Do you really want to delete this account?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            });

            // Check if the user confirmed the deletion
            if (result.isConfirmed) {
                await this.accountDelete(id);
            }
        },


        accountDelete(id) {

            Swal.fire({
                title: 'Please wait...',
                text: 'Deleting user...',
                icon: 'info',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                },
            });

            axios.delete(`${url}/users/${id}`)
                .then((response) => {
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            this.msg = true;
                            this.text = data.msg;
                        });
                    }
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: "The user has been deleted successfully.",
                    }).then((result) => {
                        if (result.value) {
                            this.getAccounts(this.selectedTab);
                            this.close();
                        }
                    });
                });
        },

        close() {
            this.adddialog = false;
            this.editdialog = false;
            this.passdialog = false;
            this.clear()
        },

        debouncedFetchData: debounce(function () {
            this.options.page = 1; // Reset to the first page on new search
            this.getAccounts();
        }, 1000),

        getAccounts(tabName) {
            this.selectedTab = tabName;
            const companyIds = localStorage.getItem('userCompanies');
            let {page, itemsPerPage} = this.options;
            page = page || 1;
            itemsPerPage = itemsPerPage || 10;

            let params = {
                Company: JSON.parse(companyIds),
                page: page,
                limit: itemsPerPage,
            };

            if (this.selectedTab === 'Former Users') {
                params.Status = 'Terminated';
            }

            if(this.search) {
                params.Search = this.search;
            }

            this.isLoading = true;
            let endpoint = `${url}/users/state/${this.userState}`;

            axios.get(endpoint, { params }).then(response => {
                const {users, totalUsers} = response.data;
                this.users = users;


                // Remove current user's email from the list if present
                // const currentUserIndex = this.users.findIndex(user => user.Email === localStorage.getItem('userEmail'));
                // if (currentUserIndex > -1) {
                //     this.users.splice(currentUserIndex, 1);
                // }

                this.pageCount = totalUsers / itemsPerPage;
                this.itemCount = totalUsers;

            }).catch(err => {
                console.error(err);
            }).finally(() => {
                this.isLoading = false;
            });
        },

        getPrograms: function () {
            if (localStorage.getItem('userRole') === 'Administration') {
                axios.get(`${url}/units`).then(async res => {
                    this.programs = []
                    this.programs = res.data.units
                })
            } else {
                axios.get(`${url}/units/state/${this.userState}`).then(async res => {
                    this.programs = []
                    this.programs = res.data.units
                })
            }

        },

        getCompanies: function () {
            this.isLoading = true;
            axios.get(`${url}/companies`).then(res => {
                this.companies = res.data.companies;
            }).finally(() => this.isLoading = false);
        },


        viewUser(data) {
            this.$router.push({name: 'NewHirePortal', params: {empID: data._id}})
        },

        getClients() {
            this.isLoading = true;
            axios.get(`${url}/clients`).then((response) => {
                this.clients = response.data.clients;
            }).finally(() => this.isLoading = false);
        },
        downloadDocument(url) {
            if (url) {
                window.open(url, '_blank');
            } else {
                alert('No documents available');
            }
        },

        getUserClass(user) {
            return user.RequiresSupervision ? 'red-header' : '';
        },

    },
};
</script>

<style>

.red-header {
    color: red;
}

* {
    text-decoration: none;
}
</style>

